import {HTTP} from '@/CallAPI'
export default {
  getPermissionOfGroup (group) {
    return HTTP.get('groups/' + group.id + '/permissions', {
      params: {
        per_page: 'all'
      }
    })
  },

  createPermission (group, permissions) {
    return HTTP.post('/groups/' + group.id + '/permissions', {data: permissions})
  }
}



// WEBPACK FOOTER //
// ./src/service/group-permission.js